<div class="card h-full">
  <!-- content -->
  <div class="flex gap-6 flex-1 flex-col">
    <!-- left menu -->
    <nav
      class="md:justify-start justify-center flex items-center gap-1 -mx-5 -mt-5 px-5 py-4 bg-black/5"
    >
      @for (step of steps; track step.label) {
        <a
          class="blu-tab-item"
          [routerLink]="step.routerLink"
          routerLinkActive="active"
          [ngClass]="{
            disabled:
              step.label === 'Envio' && sendService.recipients.length < 1
          }"
        >
          <span class="material-symbols-rounded">
            {{ step.icon }}
          </span>
          @if (sharedService.screenSize === 'l') {
            <h3>{{ step.label }}</h3>
          }
        </a>
        @if (!$last) {
          <span class="material-symbols-rounded text-black/40"
            >chevron_right</span
          >
        }
      }
    </nav>
    <!-- center content -->
    <router-outlet></router-outlet>
  </div>
</div>

<!-- modal -->
<router-outlet name="history-modal"></router-outlet>
